<template>
    <vs-table :data="data" >
      <template slot="header" >
        <vs-row style="display:inline">
          <vs-col vs-w="2">
            <add-button @click="add" class="mt-3"/>
          </vs-col>

            <vs-col vs-offset="7" vs-w="3" style="display:inline-flex">
             <div class="con-input-search vs-table--search">
                <input
                  class="input-search vs-table--search-input"
                  type="text"
                  v-model="text"
                  @keypress.enter="search"
                />
                <vs-icon icon="search"></vs-icon>
              </div>
              <!-- <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-filter"
                class="mx-2 mt-4"
                radius
                @click="openFilter"
              ></vs-button> -->
           </vs-col>            
        </vs-row>  
      </template>
      <template slot="thead">
        <th-sort
          :text="$t('no_order') | capitalize"
          column="dwh_review_order.no_order"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('no_entry') | capitalize"
          column="e.entry_id"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('date') | capitalize"
          column="IT.name"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('trailer') | capitalize"
          column="dwh_review_order.created_at"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('carrier') | capitalize"
          column="t1.ClientName"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('plates') | capitalize"
          column="dwh_review_order.updated_at"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('updated') | capitalize"
          column="S.name"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('status') | capitalize"
          column="S.name"
          @sort="handleClickSort"
        />
        <th class="qb-sticky">
          {{ $t('actions') }}
        </th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ data[i].no_order }}
          </vs-td>
          <vs-td>
            {{ data[i].entry_id }}
          </vs-td>
           <vs-td>
            {{ formatDate(data[i].created_at)	 }}
          </vs-td>
           <vs-td>
            {{ data[i].trailer	 }}
          </vs-td>
           <vs-td>
            {{ data[i].driver }}
          </vs-td>
           <vs-td>
            {{ data[i].plate }}
          </vs-td>
            <vs-td>
            {{ formatDate(data[i].updated_at) }}
          </vs-td>
           <vs-td>
           <vs-chip :color="data[i].status_color.toString().trim()">
             {{ data[i].status_name }}
           </vs-chip>
          </vs-td>
          <vs-td>
            <div>
               <!-- <action-pdf-viewer :files="[data[i].file]"/> -->
              <action-icon icon="ArrowRightCircleIcon" :tooltip="$t('details')" @click="showDetails(data[i].id)"/>
              <!-- <action-icon icon="FileIcon" :tooltip="$t('file')" /> -->
            </div>
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'
import AddButton from '@/views/components/buttons/AddButton'
export default {
  components: {
    ActionIcon,
    ThSort,
    AddButton,
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    add(e) {
      this.$emit('add', e)
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'review-order-filter')
    },
    showDetails(id) {
      this.$router.push({
        name: 'load-order-details',
        params: {
          id: id,
        },
      })
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>